// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","form":"styles_form__Oc5si","submit":"styles_submit__HZAcV","loading":"styles_loading__boSxp"};